/*************************** http请求封装，axios配置 ***************************/
// import Vue from 'vue'
import axios from 'axios';
import qs from 'qs';
import Vue from 'vue';
import '@/config/config.js';
import { closeGlobalMask } from "@/utils/js/utils";
var v = new Vue({});
const http = {};
const newAxios = axios.create({
    baseURL: window.config.baseURL,
    timeout: 30000,
    headers: { 'Content-Type': 'application/json' }
});

//http request 拦截器
newAxios.interceptors.request.use(
    conf => {
        if (conf.data instanceof FormData) {
            console.log('multi');
            conf.headers['Content-Type'] = null;
        } else {
            conf.data = JSON.stringify(conf.data);
        }

        return conf;
    },
    error => {
        v.$cls();
        v.$notify_err(error);
        return Promise.reject(error);
    }
);

//http response 拦截器
newAxios.interceptors.response.use(
    response => {
        if (response.data.code != '200') {
            console.log(`接口异常  url:${response.config.url}  code:${response.data.code}`);
        }
        return response;
    },
    error => {
        v.$cls();
        if (/429/.test(error.message)) {
            v.$notify_err('前方堵塞,请刷新后再试~');
        } else {
            closeGlobalMask();
            v.$notify_err('服务端响应异常');
            
        }

        return Promise.reject(error);
    }
);

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
http.get = function(params) {
    return new Promise((resolve, reject) => {
        const url = params.url + `?${qs.stringify(params.data)}`;
        newAxios
            .get(url)
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                v.$cls();
                console.error(err);
                reject(err);
            });
    });
};

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
http.post = function(params) {
    return new Promise((resolve, reject) => {
        // 如果配置了其他域名地址
        newAxios.post(params.url, params.data).then(
            response => {
                resolve(response.data);
            },
            err => {
                v.$cls();
                console.error(err);
                reject(err);
            }
        );
    });
};

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */
http.patch = function(url, data = {}) {
    return new Promise((resolve, reject) => {
        newAxios.patch(url, data).then(
            response => {
                resolve(response.data);
            },
            err => {
                reject(err);
            }
        );
    });
};

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */
http.put = function(url, data = {}) {
    return new Promise((resolve, reject) => {
        newAxios.put(url, data).then(
            response => {
                resolve(response.data);
            },
            err => {
                reject(err);
            }
        );
    });
};

export default http;
